import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=3b1549be&scoped=true"
import script from "./nft.vue?vue&type=script&lang=js"
export * from "./nft.vue?vue&type=script&lang=js"
import style0 from "./nft.vue?vue&type=style&index=0&id=3b1549be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1549be",
  null
  
)

export default component.exports